import React from "react";
import { Layout } from "../../nq-component";
import NavBar2 from "../Navbar2Custom";

function NavBar(props) {
  const { collapsed, setCollapse } = React.useContext(Layout.Context);

  function onClickNavigate() {
    setCollapse(!collapsed);
  }

  return (
    <NavBar2
      className="shadow-sm"
      logo=""
      //   title="DASHBOARD"
      onClickNavigate={onClickNavigate}
      user={props.user}
      {...props}
    />
  );
}

export default NavBar;
